<template>
  <v-col cols="5">
      <v-card
    class="mx-auto"
    max-width="500"
  >
  <v-card-title v-text="rollTitle"></v-card-title>
    <v-list flat>
      <v-list-item-group v-model="selected" :multiple="cumulative">
        <v-list-item
          v-for="(item, i) in items"
          :key="i"
          :class="item.active ? 'selected' : ''"
        >
          <v-list-item-content disabled selectable="false">
            <v-list-item-title v-text="item.text"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-card>
  </v-col>
</template>

  <script>
      export default {
        name: 'SimpleRouletteCard',
        props: {
          rollTitle: String,
          cumulative: Boolean,
          items: Array,
          rolled: Boolean
        },
        data: function () {
          return {
            rolledItem: '',
            rolling: false,
            selected: []
          }
        },
        methods:{

        },
        watch: {
          rolled: {
            immediate: true, 
            handler (val, oldVal) {
              this.rolledTitle = this.rollTitle;
              if(val){
                let rollingRandom = setInterval(()=>{
                  this.selected.active = false;
                  let randomIndex = Math.floor(Math.random() * this.items.length);
                  this.selected = this.items[randomIndex];
                  this.selected.active = true;
                }, 150);
                this.rolling = true;
                console.log("Running initial roll animation");
                setTimeout(()=>{
                  console.log("Time up");
                  this.items.forEach(function(item){
                    item.active = false;
                  })
                  this.rolling = false;
                  this.rolled = val;
                  let randomIndex = Math.floor(Math.random() * this.items.length);
                  if(this.cumulative){
                    this.selected = this.items.slice(0, (randomIndex + 1));
                    let referenceItems = this.items;
                    this.selected.forEach(function(item){
                      referenceItems[referenceItems.indexOf(item)].active = true;
                    });
                    this.items = referenceItems;
                  } else {
                    this.selected = this.items[randomIndex];
                    this.selected.active = true;
                  }
                  console.log(this.items);
                  clearInterval(rollingRandom);
                }, 3000);
              }
            }
          },

        }
      }
  </script>

  <style scoped>
      .selected {
        background-color: darkgrey;
        color: white
      }
  </style>